var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskSubmittedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5837 20.3895C11.8837 20.5895 11.0837 20.6895 10.2837 20.6895C4.78369 20.6895 0.283691 16.1895 0.283691 10.6895C0.283691 5.18945 4.78369 0.689453 10.2837 0.689453C11.5837 0.689453 12.8837 0.989453 14.0837 1.38945L12.4837 2.98945C11.7837 2.78945 11.0837 2.68945 10.2837 2.68945C5.88369 2.68945 2.28369 6.28945 2.28369 10.6895C2.28369 15.0895 5.88369 18.6895 10.2837 18.6895C10.6837 18.6895 11.1837 18.6895 11.5837 18.5895C11.7837 19.2895 12.1837 19.8895 12.5837 20.3895ZM6.18369 8.78945L4.78369 10.1895L9.28369 14.6895L19.2837 4.68945L17.8837 3.28945L9.28369 11.8895L6.18369 8.78945ZM16.2837 12.6895V15.6895H13.2837V17.6895H16.2837V20.6895H18.2837V17.6895H21.2837V15.6895H18.2837V12.6895H16.2837Z",
    fill: "#13343B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskSubmittedIcon);
export default __webpack_public_path__ + "static/media/task_submitted_icon.0adf3546ec657c8f95aae74cb56b22b8.svg";
export { ForwardRef as ReactComponent };